import AllocationsPage from "features/allocations/AllocationsPage";
import MyAllocationsPage from "features/allocations/MyAllocationsPage";
import BusinessIntelligencePage from "features/business-intelligence/BusinessIntelligencePage";
import ErrorTestPage from "app/pages/ErrorTestPage";
import Home from "app/pages/Home";
import ProjectsMainPage from "features/projects/ProjectsMainPage";
import RedirectToPage from "app/pages/RedirectTo";
import SessionExpired from "app/pages/SessionExpired";
import TimesheetMainPage from "features/timesheet/TimesheetMain";
import TimesheetsPage from "features/timesheet/TimesheetsPage";
import Unauthorized from "app/pages/Unauthorized";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";

import AbsenseReasons from "features/admin/absense-reasons/AbsenseReasons";
import AccessGroupLanding from "features/admin/access-groups/single/AccessGroupLanding";
import AccessGroupLayout from "features/admin/access-groups/single/AccessGroupLayout";
import AccessGroupMembers from "features/admin/access-groups/single/AccessGroupMembers";
import AccessGroupPageAccessPage from "features/admin/access-groups/single/AccessGroupPageAccessPage";
import AccessGroups from "features/admin/access-groups/AccessGroups";
import AdminMainPage from "features/admin/AdminMainPage";
import Agencies from "features/admin/agencies/Agencies";
import { AllocationsPageContextProvider } from "features/allocations/contexts/AllocationsPageContext";
import ClientContactsAndRateCards from "features/admin/clients/single/ClientContactsAndRateCards";
import ClientFamilyCorp from "features/admin/client-families/ClientFamilyCorp";
import ClientGroups from "features/admin/clients/single/ClientGroups";
import Clients from "features/admin/clients/Clients";
import ClientsLayout from "features/admin/clients/single/ClientsLayout";
import DailyTimesheetPage from "features/daily-timesheet/DailyTimesheetPage";
import { DrawerContextProvider } from "shared/contexts/DrawerContext";
import Holidays from "features/admin/holidays/Holidays";
import IncompleteTimesheet from "features/timesheet/incomplete-timesheet/IncompleteTimesheet";
import ManageTimeOff from "features/timesheet/manage-time-off/ManageTimeOff";
import { ManageTimeOffContextProvider } from "features/timesheet/contexts/ManageTimeOffContext";
import Offices from "features/admin/offices/Offices";
import ProjectPlanner from "features/projects/planner/ProjectPlanner";
import Projects from "features/admin/projects/Projects";
import ProjectsDashboard from "features/projects/project-dashboard/ProjectsDashboard";
import ProjectsDashboardDetails from "features/projects/project-dashboard/single/ProjectsDashboardDetails";
import ProjectsDashboardLayout from "features/projects/project-dashboard/single/ProjectsDashboardLayout";
import { ProjectsDashboardLayoutContextProvider } from "features/projects/contexts/ProjectsDashboardLayoutContext";
import ProjectsDashboardNotes from "features/projects/project-dashboard/single/ProjectsDashboardNotes";
import ProjectsDashboardOverview from "features/projects/project-dashboard/single/ProjectsDashboardOverview";
import ProjectsLayout from "features/admin/projects/single/ProjectsLayout";
import ProjectsLinked from "features/admin/projects/single/ProjectsLinked";
import React from "react";
import Regions from "features/admin/regions/Regions";
import Retainers from "features/admin/retainers/Retainers";
import RetainersDashboard from "features/projects/retainers-dashboard/RetainersDashboard";
import RetainersDashboardDetails from "features/projects/retainers-dashboard/single/RetainersDashboardDetails";
import RetainersDashboardLayout from "features/projects/retainers-dashboard/single/RetainersDashboardLayout";
import { RetainersDashboardLayoutContextProvider } from "features/projects/contexts/RetainersDashboardLayoutContext";
import RetainersDashboardNotes from "features/projects/retainers-dashboard/single/RetainersDashboardNotes";
import RetainersDashboardOverview from "features/projects/retainers-dashboard/single/RetainersDashboardOverview";
import { TSHolidays } from "features/timesheet/holidays/TSHolidays";
import TimesheetGrid from "features/timesheet/timesheet-grid/TimesheetGrid";
import { TimesheetGridContextProvider } from "features/timesheet/contexts/TimesheetGridContext";
import UserTimeOff from "features/timesheet/time-off/UserTimeOff";
import { WeekNavigatorContextProvider } from "shared/contexts/WeekNavigatorContext";

function AppRoutes() {
    const location = useLocation();
    return (
        <Routes>
            <Route path="test/error" element={<ErrorTestPage />} />

            <Route
                path={globalThis.config.routes.sessionExpired}
                element={<SessionExpired />}
            />

            <Route
                path={globalThis.config.routes.myAllocations}
                element={<MyAllocationsPage />}
            />

            <Route
                path={globalThis.config.routes.allocation}
                element={
                    <AllocationsPageContextProvider key={location.search}>
                        <AllocationsPage />
                    </AllocationsPageContextProvider>
                }
            />

            <Route
                path={globalThis.config.routes.unauthorized}
                element={<Unauthorized />}
            />

            <Route path="/" element={<Home />} />

            <Route
                path={globalThis.config.routes.dailyTimesheet}
                element={<DailyTimesheetPage />}
            />

            <Route
                path={globalThis.config.routes.businessIntelligenceLandingPage}
                element={<BusinessIntelligencePage />}
            />

            <Route
                path={globalThis.config.routes.adminLandingPage}
                element={<AdminMainPage />}
            />

            <Route
                path={globalThis.config.routes.adminAgenciesLanding}
                element={<Agencies />}
            />

            <Route
                path={globalThis.config.routes.adminAbsenseReasons}
                element={<AbsenseReasons />}
            />

            <Route
                path={globalThis.config.routes.adminClientFamilyCorp}
                element={<ClientFamilyCorp />}
            />

            <Route
                path={globalThis.config.routes.adminAccessGroupsLanding}
                element={
                    <DrawerContextProvider>
                        <AccessGroups />
                    </DrawerContextProvider>
                }
            />

            <Route
                path="/admin/accessgroups/:groupId"
                element={<AccessGroupLayout />}
            >
                <Route
                    index
                    element={<Navigate to="members" replace={true} />}
                />
                <Route path="members" element={<AccessGroupMembers />} />
                <Route
                    index
                    element={<Navigate to="pageaccess" replace={true} />}
                />
                <Route
                    path="pageaccess"
                    element={<AccessGroupPageAccessPage />}
                />
                <Route
                    index
                    element={<Navigate to="landing" replace={true} />}
                />
                <Route path="landing" element={<AccessGroupLanding />} />
            </Route>

            <Route
                path={globalThis.config.routes.adminRegionsLanding}
                element={<Regions />}
            />

            <Route
                path={globalThis.config.routes.adminOfficesLanding}
                element={<Offices />}
            />

            <Route
                path={globalThis.config.routes.adminClientsLanding}
                element={<Clients />}
            />

            <Route
                path={`${globalThis.config.routes.adminClientsLanding}/:clientId`}
                element={<ClientsLayout />}
            >
                <Route
                    index
                    element={
                        <Navigate
                            to={globalThis.config.routes.adminClientsGroups}
                            replace={true}
                        />
                    }
                />
                <Route
                    path={globalThis.config.routes.adminClientGroups}
                    element={<ClientGroups />}
                />
                <Route
                    index
                    element={
                        <Navigate
                            to={
                                globalThis.config.routes
                                    .adminClientsContactsAndCards
                            }
                            replace={true}
                        />
                    }
                />
                <Route
                    path={globalThis.config.routes.adminClientContactsAndCards}
                    element={<ClientContactsAndRateCards />}
                />
            </Route>

            <Route
                path={globalThis.config.routes.adminHolidaysLanding}
                element={<Holidays />}
            />

            <Route
                path={globalThis.config.routes.adminProjectsLanding}
                element={<Projects />}
            />

            <Route
                path={`${globalThis.config.routes.adminProjectsLanding}/:projectId`}
                element={<ProjectsLayout />}
            >
                <Route
                    index
                    element={
                        <Navigate
                            to={globalThis.config.routes.adminProjectsLinked}
                            replace={true}
                        />
                    }
                />

                <Route
                    path={globalThis.config.routes.adminProjectsLinked}
                    element={<ProjectsLinked />}
                />
            </Route>

            <Route
                path={globalThis.config.routes.adminRetainersLanding}
                element={<Retainers />}
            />

            <Route path="/timesheets" element={<TimesheetsPage />} />

            <Route
                path={globalThis.config.routes.timesheetLandingPage}
                element={
                    <WeekNavigatorContextProvider>
                        <TimesheetGridContextProvider>
                            <ManageTimeOffContextProvider>
                                <TimesheetMainPage />
                            </ManageTimeOffContextProvider>
                        </TimesheetGridContextProvider>
                    </WeekNavigatorContextProvider>
                }
            >
                <Route
                    index
                    element={
                        <Navigate
                            to={globalThis.config.routes.timesheetGrid}
                            replace={true}
                        />
                    }
                />
                <Route
                    path={globalThis.config.routes.timesheetGrid}
                    element={<TimesheetGrid />}
                />
                <Route
                    index
                    element={
                        <Navigate
                            to={globalThis.config.routes.timesheetIncomplete}
                            replace={true}
                        />
                    }
                />
                <Route
                    path={globalThis.config.routes.timesheetIncomplete}
                    element={<IncompleteTimesheet />}
                />
                <Route
                    index
                    element={
                        <Navigate
                            to={globalThis.config.routes.timeOff}
                            replace={true}
                        />
                    }
                />
                <Route
                    path={globalThis.config.routes.timeOff}
                    element={<UserTimeOff />}
                />
                <Route
                    index
                    element={
                        <Navigate
                            to={globalThis.config.routes.manageTimeOff}
                            replace={true}
                        />
                    }
                />
                <Route
                    path={globalThis.config.routes.manageTimeOff}
                    element={<ManageTimeOff />}
                />

                <Route
                    index
                    element={
                        <Navigate
                            to={globalThis.config.routes.timesheetHolidays}
                            replace={true}
                        />
                    }
                />

                <Route
                    path={globalThis.config.routes.timesheetHolidays}
                    element={<TSHolidays />}
                />
            </Route>

            <Route
                path={globalThis.config.routes.projectLanding}
                element={<ProjectsMainPage />}
            ></Route>

            <Route
                path={
                    globalThis.config.routes.projectsRetainersDashboardLanding
                }
                element={<RetainersDashboard />}
            />

            <Route
                path={`${globalThis.config.routes.projectsRetainersDashboardLanding}/:retainerId`}
                element={
                    <RetainersDashboardLayoutContextProvider>
                        <RetainersDashboardLayout />
                    </RetainersDashboardLayoutContextProvider>
                }
            >
                <Route
                    index
                    element={<Navigate to="overview" replace={true} />}
                />
                <Route
                    path="overview"
                    element={<RetainersDashboardOverview />}
                />
                <Route
                    index
                    element={<Navigate to="details" replace={true} />}
                />
                <Route path="details" element={<RetainersDashboardDetails />} />
                <Route index element={<Navigate to="notes" replace={true} />} />
                <Route path="notes" element={<RetainersDashboardNotes />} />
            </Route>

            <Route
                path={globalThis.config.routes.projectsDashboardLanding}
                element={<ProjectsDashboard />}
            />

            <Route
                path={`${globalThis.config.routes.projectsDashboardLanding}/:projectId`}
                element={
                    <ProjectsDashboardLayoutContextProvider>
                        <ProjectsDashboardLayout />
                    </ProjectsDashboardLayoutContextProvider>
                }
            >
                <Route
                    index
                    element={<Navigate to="overview" replace={true} />}
                />

                <Route
                    path="overview"
                    element={<ProjectsDashboardOverview />}
                />

                <Route
                    index
                    element={<Navigate to="details" replace={true} />}
                />

                <Route path="details" element={<ProjectsDashboardDetails />} />

                <Route index element={<Navigate to="notes" replace={true} />} />

                <Route path="notes" element={<ProjectsDashboardNotes />} />
            </Route>

            <Route path="/redirectto" element={<RedirectToPage />}></Route>

            <Route
                path={globalThis.config.routes.projectPlanner}
                element={<ProjectPlanner />}
            />
        </Routes>
    );
}

export default AppRoutes;
